"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ListWorkflowTemplatesQuery () {
        return ListWorkflowTemplatesQuery;
    },
    get WorkflowTemplateSortBySchema () {
        return WorkflowTemplateSortBySchema;
    }
});
const _zod = require("zod");
const WorkflowTemplateSortBySchema = _zod.z.enum([
    "name",
    "last_update",
    "todoCount"
]);
const ListWorkflowTemplatesQuery = _zod.z.object({
    sortBy: WorkflowTemplateSortBySchema.default("name"),
    sortOrder: _zod.z.enum([
        "asc",
        "desc"
    ]).default("asc"),
    limit: _zod.z.coerce.number().int().min(1).max(100).default(25),
    skip: _zod.z.coerce.number().int().min(0).default(0)
});
